import { mixpanel } from "../mixpanel";

export function mixpanelTrack(event: string, props?: Record<string, string>) {
    if (!import.meta.env.VITE_APP_MIXPANEL_TOKEN) return;
    mixpanel?.track(event, props);
}
